// Util
import { createSmartSelector } from '../milanoteReselect/milanoteReselect';
import { isOnline } from '../../user/userUtil';
import { toIdArray } from '../../../common/utils/immutableHelper';

// Selectors
import { getUsers } from '../../user/usersSelector';
import { getCurrentUserId } from '../../user/currentUserSelector';

// Constants
import { USER_IDLE_TIMEOUT_MILLISECONDS } from '../../../common/users/userConstants';

export const getTrackedUserIds = createSmartSelector(getUsers, (trackedUserIds) => trackedUserIds.keySeq().toArray());

export const getHasConnectedUsers = createSmartSelector(
    getTrackedUserIds,
    (trackedUserIds) => trackedUserIds.length > 1,
);

const getCurrentlyViewedBoardIds = (users) =>
    users.reduce((boardIds, user) => {
        const usersCurrentBoardId = user.get('currentBoardId');
        if (!!usersCurrentBoardId && boardIds.indexOf(usersCurrentBoardId) === -1) {
            boardIds.push(usersCurrentBoardId);
        }
        return boardIds;
    }, []);

export const getRemoteCurrentlyViewedBoardIds = createSmartSelector(getUsers, getCurrentlyViewedBoardIds);

export const getOnlineUsers = createSmartSelector(getUsers, (users) => users.filter(isOnline));

export const getRemoteActiveCurrentlyViewedBoardIds = createSmartSelector(getOnlineUsers, getCurrentlyViewedBoardIds);

export const getIdleOnlineUsers = createSmartSelector(
    getOnlineUsers,
    getCurrentUserId,
    (onlineUsers, currentUserId) => {
        const currentTime = Date.now();
        // Find every user that might be stale because we haven't heard from them within the idle timeout
        const idleTimestamp = currentTime - USER_IDLE_TIMEOUT_MILLISECONDS;
        return onlineUsers.filter((user) => user.get('timestamp') < idleTimestamp && currentUserId !== user.get('_id'));
    },
);

export const getIdleOnlineUserIds = createSmartSelector(getIdleOnlineUsers, toIdArray);
